export class StudentTagModel implements IStudentTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;

  constructor(data?: IStudentTagModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.tag = Data["tag"];
      this.dateAdded = Data["dateAdded"];
    }
  }

  static fromJS(data: any): StudentTagModel {
    data = typeof data === 'object' ? data : {};
    let result = new StudentTagModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tag"] = this.tag;
    data["dateAdded"] = this.dateAdded;
    return data;
  }
}

export interface IStudentTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;
}
